import styled, { css } from "styled-components";
import {
  Modal as AntModal,
  Button as AntButton,
  Progress as AntProgress,
} from "antd";

export const StyledModal = styled(AntModal)`
  .ant-modal-header {
    border-radius: 0.3rem 0.3rem 0 0;
  }

  .ant-modal-content {
    border-radius: 0.3rem;
  }

  .ant-modal-body {
    padding: 1.5rem;
  }

  &.ant-modal-wrap {
    z-index: 1050 !important;
  }

  & + .ant-modal-mask {
    z-index: 1049 !important;
  }
`;

export const ProgressContainer = styled.div`
  margin-bottom: 1.25rem;
`;

export const StyledProgress = styled(AntProgress)`
  .ant-progress-bg {
    background-color: var(--orange-150);
  }
`;

export const LogsContainer = styled.div`
  max-height: 25rem;
  overflow-y: auto;
  padding: 1rem;
  border: 0.0625rem solid #d9d9d9;
  border-radius: 0.3rem;
  background-color: #fafafa;
`;

export const LogMessage = styled.div<{ type: "success" | "error" | "info" }>`
  margin-bottom: 0.5rem;
  padding: 0.375rem 0.5rem;
  border-radius: 0.2rem;

  ${({ type }) => {
    switch (type) {
      case "error":
        return css`
          color: #ff4d4f;
          background-color: rgba(255, 77, 79, 0.1);
        `;
      case "success":
        return css`
          color: #52c41a;
          background-color: rgba(82, 196, 26, 0.1);
        `;
      case "info":
      default:
        return css`
          color: #1890ff;
          background-color: rgba(24, 144, 255, 0.1);
        `;
    }
  }}
`;

export const EmptyLogs = styled.div`
  text-align: center;
  color: #1890ff;
  padding: 1rem;
`;

interface ButtonProps {
  type?: "primary" | "default";
}

export const Button = styled(AntButton)<ButtonProps>`
  border-radius: 0.3rem;
  ${({ type }) => {
    if (type === "primary") {
      return css`
        background-color: var(--orange-150);
        &&&:hover,
        &&&:focus,
        &&&:active,
        &&&:focus-within {
          background-color: rgb(255, 132, 0);
        }
      `;
    }
    return css`
      background-color: var(--gray-100);
      &&&:hover,
      &&&:focus,
      &&&:active,
      &&&:focus-within {
        background-color: rgb(209, 209, 209);
        color: #333;
      }
    `;
  }}
`;

export const FooterContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
`;
